import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import CreateDiameterPopup from '../popups/diameters/CreateDiameterPopup'
import UpdateDiameterPopup from '../popups/diameters/UpdateDiameterPopup'
import CreateBatteryPopup from '../popups/batteries/CreateBatteryPopup'
import UpdateBatteryPopup from '../popups/batteries/UpdateBatteryPopup'
import CreateOwnerPopup from '../popups/owners/CreateOwnerPopup'
import UpdateOwnerPopup from '../popups/owners/UpdateOwnerPopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import DiametersListAction from '../../actions/diameters/ListAction'
import DiametersDeleteAction from '../../actions/diameters/DeleteAction'
import BatteriesListAction from '../../actions/batteries/ListAction'
import BatteriesDeleteAction from '../../actions/batteries/DeleteAction'
import OwnersListAction from '../../actions/owners/ListAction'
import OwnersPrintAction from '../../actions/print/PrintOwnerAction'
import OwnersDeleteAction from '../../actions/owners/DeleteAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

class SettingsPage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      diametersCreate: false,
      diametersUpdate: null,
      diametersDelete: null,
      batteriesCreate: false,
      batteriesUpdate: null,
      batteriesDelete: null,
      ownersCreate: false,
      ownersUpdate: null,
      ownersDelete: null
    }

    // Bind events
    this.onClickCreateDiameter = this.onClickCreateDiameter.bind(this)
    this.onCloseCreateDiameter = this.onCloseCreateDiameter.bind(this)
    this.onClickUpdateDiameter = this.onClickUpdateDiameter.bind(this)
    this.onCloseUpdateDiameter = this.onCloseUpdateDiameter.bind(this)
    this.onClickDeleteDiameter = this.onClickDeleteDiameter.bind(this)
    this.onConfirmDeleteDiameter = this.onConfirmDeleteDiameter.bind(this)
    this.onClickCreateBattery = this.onClickCreateBattery.bind(this)
    this.onCloseCreateBattery = this.onCloseCreateBattery.bind(this)
    this.onClickUpdateBattery = this.onClickUpdateBattery.bind(this)
    this.onCloseUpdateBattery = this.onCloseUpdateBattery.bind(this)
    this.onClickDeleteBattery = this.onClickDeleteBattery.bind(this)
    this.onConfirmDeleteBattery = this.onConfirmDeleteBattery.bind(this)
    this.onClickCreateOwner = this.onClickCreateOwner.bind(this)
    this.onCloseCreateOwner = this.onCloseCreateOwner.bind(this)
    this.onClickPrintOwner = this.onClickPrintOwner.bind(this)
    this.onClickUpdateOwner = this.onClickUpdateOwner.bind(this)
    this.onCloseUpdateOwner = this.onCloseUpdateOwner.bind(this)
    this.onClickDeleteOwner = this.onClickDeleteOwner.bind(this)
    this.onConfirmDeleteOwner = this.onConfirmDeleteOwner.bind(this)
  }

  componentDidMount() {
    this.props.diametersFetch()
    this.props.batteriesFetch()
    this.props.ownersFetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After a diameter has been deleted, refresh
    if (
      prevProps.diameterDeleteIsFetching
      &&
      !this.props.diameterDeleteIsFetching
    ) {
      this.setState({
        diametersDelete: null
      })
      AppUtils.setStatus(
        this.props.diameterDeleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.diameterDeleteError
          ? AppUtils.errorToText(this.props.diameterDeleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Ce diamètre est utilisé.'
            })
          : 'Diamètre supprimé.'
      )
      if (!this.props.diameterDeleteError) {
        this.props.diametersFetch()
      }
    }

    // After a battery has been deleted, refresh
    if (
      prevProps.batteryDeleteIsFetching
      &&
      !this.props.batteryDeleteIsFetching
    ) {
      this.setState({
        batteriesDelete: null
      })
      AppUtils.setStatus(
        this.props.batteryDeleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.batteryDeleteError
          ? AppUtils.errorToText(this.props.batteryDeleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Ce modèle de batterie est utilisé.'
            })
          : 'Modèle de batterie supprimé.'
      )
      if (!this.props.batteryDeleteError) {
        this.props.batteriesFetch()
      }
    }

    // After an owner has been deleted, refresh
    if (
      prevProps.ownerDeleteIsFetching
      &&
      !this.props.ownerDeleteIsFetching
    ) {
      this.setState({
        ownersDelete: null
      })
      AppUtils.setStatus(
        this.props.ownerDeleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.ownerDeleteError
          ? AppUtils.errorToText(this.props.ownerDeleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Ce groupe matériel est utilisé.'
            })
          : 'Groupe matériel supprimé.'
      )
      if (!this.props.ownerDeleteError) {
        this.props.ownersFetch()
      }
    }
  }

  onClickCreateDiameter() {
    this.setState({
      diametersCreate: true
    })
  }

  onCloseCreateDiameter(isDirty) {
    this.setState({
      diametersCreate: false
    })
    if (isDirty) {
      this.props.diametersFetch()
    }
  }

  onClickUpdateDiameter(id) {
    return () => {
      this.setState({
        diametersUpdate: id
      })
    }
  }

  onCloseUpdateDiameter(isDirty) {
    this.setState({
      diametersUpdate: null
    })
    if (isDirty) {
      this.props.diametersFetch()
    }
  }

  onClickDeleteDiameter(id) {
    return () => {
      this.setState({
        diametersDelete: id
      })
    }
  }

  onConfirmDeleteDiameter(proceed) {
    if (proceed) {
      this.props.diameterDelete(this.state.diametersDelete)
    }
    else {
      this.setState({
        diametersDelete: null
      })
    }
  }

  onClickCreateBattery() {
    this.setState({
      batteriesCreate: true
    })
  }

  onCloseCreateBattery(isDirty) {
    this.setState({
      batteriesCreate: false
    })
    if (isDirty) {
      this.props.batteriesFetch()
    }
  }

  onClickUpdateBattery(id) {
    return () => {
      this.setState({
        batteriesUpdate: id
      })
    }
  }

  onCloseUpdateBattery(isDirty) {
    this.setState({
      batteriesUpdate: null
    })
    if (isDirty) {
      this.props.batteriesFetch()
    }
  }

  onClickDeleteBattery(id) {
    return () => {
      this.setState({
        batteriesDelete: id
      })
    }
  }

  onConfirmDeleteBattery(proceed) {
    if (proceed) {
      this.props.batteryDelete(this.state.batteriesDelete)
    }
    else {
      this.setState({
        batteriesDelete: null
      })
    }
  }

  onClickCreateOwner() {
    this.setState({
      ownersCreate: true
    })
  }

  onCloseCreateOwner(isDirty) {
    this.setState({
      ownersCreate: false
    })
    if (isDirty) {
      this.props.ownersFetch()
    }
  }

  onClickPrintOwner(id) {
    return () => {
      this.props.ownerPrint(id)
    }
  }

  onClickUpdateOwner(id) {
    return () => {
      this.setState({
        ownersUpdate: id
      })
    }
  }

  onCloseUpdateOwner(isDirty) {
    this.setState({
      ownersUpdate: null
    })
    if (isDirty) {
      this.props.ownersFetch()
    }
  }

  onClickDeleteOwner(id) {
    return () => {
      this.setState({
        ownersDelete: id
      })
    }
  }

  onConfirmDeleteOwner(proceed) {
    if (proceed) {
      this.props.ownerDelete(this.state.ownersDelete)
    }
    else {
      this.setState({
        ownersDelete: null
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='1 1 28%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Diamètres de tuyaux'
              right={
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreateDiameter}
                  />
                </Grant>
              }
            />
            <Table
              columns={[
                // Diamètre
                ColumnsProvider.diameterDiameter,
                // Actions
                ColumnsProvider.actionsUpdateDelete(
                  this.onClickUpdateDiameter,
                  this.onClickDeleteDiameter
                )
              ]}
              data={this.props.diametersList}
              error={this.props.diametersError}
              isLoading={this.props.diametersIsFetching}
              emptyMessage="Il n'existe aucun diamètre de tuyau pour le moment."
            />
          </Page.Element>
          <Page.Element
            flex='1 1 28%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Modèles de batteries'
              right={
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreateBattery}
                  />
                </Grant>
              }
            />
            <Table
              columns={[
                // Nom
                ColumnsProvider.genericName,
                // Actions
                ColumnsProvider.actionsUpdateDelete(
                  this.onClickUpdateBattery,
                  this.onClickDeleteBattery
                )
              ]}
              data={this.props.batteriesList}
              error={this.props.batteriesError}
              isLoading={this.props.batteriesIsFetching}
              emptyMessage="Il n'existe aucun modèle de batterie pour le moment."
            />
          </Page.Element>
          <Page.Element
            flex='1 1 44%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Groupes matériels'
              right={
                <Grant role={Grant.ROLE.MANAGE}>
                  <Button
                    compact={true}
                    icon='plus'
                    content='Créer'
                    color='green'
                    onClick={this.onClickCreateOwner}
                  />
                </Grant>
              }
            />
            <Table
              columns={[
                // Nom
                ColumnsProvider.genericName,
                // Responsable
                ColumnsProvider.ownerManager,
                // Actions
                ColumnsProvider.actionsPrintUpdateDelete(
                  this.onClickPrintOwner,
                  this.onClickUpdateOwner,
                  this.onClickDeleteOwner
                )
              ]}
              data={this.props.ownersList}
              error={this.props.ownersError}
              isLoading={this.props.ownersIsFetching}
              emptyMessage="Il n'existe aucun groupe matériel pour le moment."
            />
          </Page.Element>
        </Page>
        {
          this.state.diametersCreate
            ? <CreateDiameterPopup
                onClose={this.onCloseCreateDiameter}
              />
            : null
        }
        {
          !_.isNull(this.state.diametersUpdate)
            ? <UpdateDiameterPopup
                id={this.state.diametersUpdate}
                onClose={this.onCloseUpdateDiameter}
              />
            : null
        }
        {
          !_.isNull(this.state.diametersDelete)
            ? <Confirm
                header="Suppression d'un diamètre"
                body="Êtes-vous sûr de vouloir supprimer ce diamètre de tuyau ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.diameterDeleteIsFetching}
                callback={this.onConfirmDeleteDiameter}
              />
            : null
        }
        {
          this.state.batteriesCreate
            ? <CreateBatteryPopup
                onClose={this.onCloseCreateBattery}
              />
            : null
        }
        {
          !_.isNull(this.state.batteriesUpdate)
            ? <UpdateBatteryPopup
                id={this.state.batteriesUpdate}
                onClose={this.onCloseUpdateBattery}
              />
            : null
        }
        {
          !_.isNull(this.state.batteriesDelete)
            ? <Confirm
                header="Suppression d'un modèle de batterie"
                body="Êtes-vous sûr de vouloir supprimer ce modèle de batterie ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.batteryDeleteIsFetching}
                callback={this.onConfirmDeleteBattery}
              />
            : null
        }
        {
          this.state.ownersCreate
            ? <CreateOwnerPopup
                onClose={this.onCloseCreateOwner}
              />
            : null
        }
        {
          !_.isNull(this.state.ownersUpdate)
            ? <UpdateOwnerPopup
                id={this.state.ownersUpdate}
                onClose={this.onCloseUpdateOwner}
              />
            : null
        }
        {
          !_.isNull(this.state.ownersDelete)
            ? <Confirm
                header="Suppression d'un groupe matériel"
                body="Êtes-vous sûr de vouloir supprimer ce groupe matériel ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.ownerDeleteIsFetching}
                callback={this.onConfirmDeleteOwner}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

SettingsPage.propTypes = {
  // Properties

  // Redux State
  diametersList: PropTypes.array,
  diametersIsFetching: PropTypes.bool.isRequired,
  diametersError: PropTypes.object,
  diameterDeleteIsFetching: PropTypes.bool.isRequired,
  diameterDeleteError: PropTypes.object,
  batteriesList: PropTypes.array,
  batteriesIsFetching: PropTypes.bool.isRequired,
  batteriesError: PropTypes.object,
  batteryDeleteIsFetching: PropTypes.bool.isRequired,
  batteryDeleteError: PropTypes.object,
  ownersList: PropTypes.array,
  ownersIsFetching: PropTypes.bool.isRequired,
  ownersError: PropTypes.object,
  ownerDeleteIsFetching: PropTypes.bool.isRequired,
  ownerDeleteError: PropTypes.object,

  // Redux Actions
  diametersFetch: PropTypes.func.isRequired,
  diameterDelete: PropTypes.func.isRequired,
  diametersClearError: PropTypes.func.isRequired,
  batteriesFetch: PropTypes.func.isRequired,
  batteryDelete: PropTypes.func.isRequired,
  batteriesClearError: PropTypes.func.isRequired,
  ownersFetch: PropTypes.func.isRequired,
  ownerPrint: PropTypes.func.isRequired,
  ownerDelete: PropTypes.func.isRequired,
  ownersClearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    diametersList: state.entities.diameters.list.data,
    diametersIsFetching: state.entities.diameters.list.isFetching,
    diametersError: state.entities.diameters.list.error,
    diameterDeleteIsFetching: state.entities.diameters.delete.isFetching,
    diameterDeleteError: state.entities.diameters.delete.error,
    batteriesList: state.entities.batteries.list.data,
    batteriesIsFetching: state.entities.batteries.list.isFetching,
    batteriesError: state.entities.batteries.list.error,
    batteryDeleteIsFetching: state.entities.batteries.delete.isFetching,
    batteryDeleteError: state.entities.batteries.delete.error,
    ownersList: state.entities.owners.list.data,
    ownersIsFetching: state.entities.owners.list.isFetching,
    ownersError: state.entities.owners.list.error,
    ownerDeleteIsFetching: state.entities.owners.delete.isFetching,
    ownerDeleteError: state.entities.owners.delete.error
  }),
  (dispatch) => ({
    diametersFetch: () => (dispatch(DiametersListAction({}))),
    diameterDelete: (id) => (dispatch(DiametersDeleteAction({ id }))),
    diametersClearError: () => (dispatch(ClearErrorAction(Types.DIAMETERS.LIST))),
    batteriesFetch: () => (dispatch(BatteriesListAction({}))),
    batteryDelete: (id) => (dispatch(BatteriesDeleteAction({ id }))),
    batteriesClearError: () => (dispatch(ClearErrorAction(Types.BATTERIES.LIST))),
    ownersFetch: () => (dispatch(OwnersListAction({}))),
    ownerPrint: (id) => (dispatch(OwnersPrintAction({ id }))),
    ownerDelete: (id) => (dispatch(OwnersDeleteAction({ id }))),
    ownersClearError: () => (dispatch(ClearErrorAction(Types.OWNERS.LIST)))
  })
)(SettingsPage)



// WEBPACK FOOTER //
// ./src/containers/pages/SettingsPage.js